import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { func, string } from 'prop-types';
import { Search, CloseCircleFilled } from '@magalu/stereo-ui-icons';
import { Input, ContainerInput, Wrapper } from './filter-input.styles';
import HiddenLabel from '../HiddenLabel';

const FilterInput = _ref => {
  let {
    onChange,
    onClearInput,
    label
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["onChange", "onClearInput", "label"]);

  const [value, setValue] = useState('');

  const handleOnChange = e => {
    setValue(e.target.value);
    onChange(e);
  };

  const handleClearInput = e => {
    setValue('');
    onClearInput(e);
  };

  return /*#__PURE__*/React.createElement(Wrapper, props, /*#__PURE__*/React.createElement(ContainerInput, null, /*#__PURE__*/React.createElement(Search, {
    color: "#818181",
    "data-testid": "icon-search"
  }), /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(HiddenLabel, {
    text: "pesquisar por filtro",
    htmlFor: "search-filter"
  }), /*#__PURE__*/React.createElement(Input, {
    id: `search-filter ${label}`,
    value: value,
    onChange: handleOnChange,
    placeholder: `Busque por ${label}`
  })), value && /*#__PURE__*/React.createElement(CloseCircleFilled, {
    color: "#818181",
    onClick: handleClearInput,
    title: "Limpar texto"
  })));
};

FilterInput.defaultProps = {
  onChange: () => ({}),
  onClearInput: () => ({}),
  label: ''
};
process.env.NODE_ENV !== "production" ? FilterInput.propTypes = {
  onChange: func,
  onClearInput: func,
  label: string
} : void 0;
export default FilterInput;